import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-gray-search-input",
  templateUrl: "./gray-search-input.component.html",
  styleUrls: ["./gray-search-input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraySearchInputComponent {
  @Input() placeholder = "";
  @Input() icon: string | null = null;
  @Input() loading = false;
  @Input() disabled = false;
  @Input() customClass = "";

  // İstersen parent default value set edebilsin
  @Input() value = "";

  @Output() search = new EventEmitter<string>();

  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  onInput(e: Event): void {
    this.value = (e.target as HTMLInputElement).value ?? "";
  }

  onKeydown(e: KeyboardEvent): void {
    if (e.key !== "Enter") return;

    e.preventDefault();
    if (this.isDisabled) return;

    this.search.emit((this.value ?? "").trim());
  }
}
